import React, { useState, useEffect } from 'react';
import MarkdownRenderer from './MarkdownRenderer';

const MessageRenderer = ({ message, onFormSubmit, onOptionClick }) => {
  // Debug log to ensure the message has the allowMultiple flag
  useEffect(() => {
    console.log('Rendering MessageRenderer with message:', message);
  }, [message]);

  // Helper functions: use option_text if available; otherwise, use name.
  const getOptionDisplay = (option) => option.option_text || option.name;
  const getOptionValue = (option) => option.value || option.name;

  // Local state to track selected options.
  const [selected, setSelected] = useState([]);

  const toggleOption = (optionVal) => {
    if (selected.includes(optionVal)) {
      setSelected(selected.filter((o) => o !== optionVal));
    } else {
      setSelected([...selected, optionVal]);
    }
  };

  // Render multi-select UI if the question allows multiple selections.
  const renderMultiSelect = () => (
    <div>
      <MarkdownRenderer content={message.reply || message.content} />
      <div className="flex flex-col space-y-2 mt-2">
        {message.options.map((option, index) => {
          const value = getOptionValue(option);
          return (
            <label key={index} className="flex items-center space-x-2">
              <input
                type="checkbox"
                value={value}
                checked={selected.includes(value)}
                onChange={() => toggleOption(value)}
                className="form-checkbox h-4 w-4 text-blue-600"
              />
              <span className="text-white">{getOptionDisplay(option)}</span>
            </label>
          );
        })}
      </div>
      {/* Confirmation button */}
      <button
        onClick={() => {
          console.log('Submitting selected options:', selected);
          onOptionClick(selected);
        }}
        className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-green-700 transition-colors"
      >
        Confirm Selections
      </button>
    </div>
  );

  // Render single-select or enhanced confirmation modes.
  const renderSingleSelect = () => {
    if (message.type === "enhancedConfirmation") {
      return (
        <div>
          <MarkdownRenderer content={message.reply || message.content} />
          <div className="mt-2 p-3 border rounded-md bg-gray-700">
            <strong className="text-white">Summary:</strong>
            <MarkdownRenderer content={message.enhancedSummary} />
          </div>
          <div className="flex space-x-2 mt-2">
            {message.options.map((option, index) => (
              <button
                key={index}
                className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                onClick={() => onOptionClick(getOptionValue(option))}
              >
                {getOptionDisplay(option)}
              </button>
            ))}
          </div>
        </div>
      );
    }
    return (
      <div>
        <MarkdownRenderer content={message.reply || message.content} />
        <div className="flex space-x-2 mt-2">
          {message.options.map((option, index) => (
            <button
              key={index}
              className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              onClick={() => onOptionClick(getOptionValue(option))}
            >
              {getOptionDisplay(option)}
            </button>
          ))}
        </div>
      </div>
    );
  };

  if (message.options) {
    if (message.allowMultiple) {
      return renderMultiSelect();
    }
    if (message.options.length > 0) {
      return renderSingleSelect();
    }
  }

  // Fallback: render plain text.
  return <MarkdownRenderer content={message.content} />;
};

export default MessageRenderer;
